import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { POSITIONS } from '../../config/positions';
import { statsLeadersFiltersSelector } from 'store/modules/statspro/stats-leaders/selectors/filters-selector';
import { UPDATE_FILTER_ITEM } from 'store/modules/statspro/stats-leaders/actions';
import { getTranslation } from 'common/react/utils/translations';
import { SelectMultiple } from 'common/react/components/select-multiple';

export const StatsLeadersPositionsFilters = ({ addOnResetCallback }) => {
    const dispatch = useDispatch();

    const filters = useSelector(statsLeadersFiltersSelector);

    const updateFilterItem = (filterItem, value) => {
        dispatch(UPDATE_FILTER_ITEM.request({ filterItem, value }));
    };

    return (
        <SelectMultiple
            // @ts-ignore
            items={POSITIONS}
            getInitialSelectedItems={() => {
                return POSITIONS.filter((p) =>
                    filters.positions.includes(p.name)
                );
            }}
            label={getTranslation('label.statsLeaders.filters.position')}
            itemToString={(pos) => pos.name}
            onSelectedItemsChange={(pos) => {
                updateFilterItem(
                    'positions',
                    pos.map((p) => p.name)
                );
            }}
            addOnResetCallback={addOnResetCallback}
            getItemText={(item) => item.name}
            getItemLabel={(item) => item.name}
        />
    );
};

StatsLeadersPositionsFilters.propTypes = {
    addOnResetCallback: PropTypes.func
};
